<template>
  <div v-if="loading_page === true">
    <v-sheet
      :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
      class="pa-3"
    >
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <v-row>
      <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">ค้นหาสินค้าใกล้หมดอายุ</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 pt-0">
        <v-card elevation="4" style="border-radius: 15px">
          <v-card-text>
            <div class="pa-4">
              <v-form ref="#">
                <v-row>
                  <!-- ค้นหาล็อต -->
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div class="d-flex">
                      <div class="title_form_main">
                        <div class="logo_timeline">
                          <img src="@/assets/arin_assets/box.png" />
                        </div>
                      </div>
                      <div class="header-content py-1 pl-5 pr-5 text-center">
                        <div class="content-font">ค้นหาสินค้าใกล้หมดอายุ</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text"
                        >วันที่เริ่มต้น
                        <span class="required--text">*</span></label
                      >
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startDate"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'กรุณาเลือกวันที่เริ่มต้น']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          @input="startDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-form-group>
                  </v-col>
                  <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                    <v-form-group>
                      <label class="label_form_text"
                        >วันที่สิ้นสุด
                        <span class="required--text">*</span></label
                      >
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endDate"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'กรุณาเลือกวันที่สิ้นสุด']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          :min="startDate"
                          @input="endDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-form-group>
                  </v-col>
                  <v-col
                    class="mt-2"
                    xs="12"
                    sm="12"
                    md="1"
                    lg="1"
                    xl="1"
                    cols="12"
                  >
                    <div
                      class="title_page ma-3"
                      style="justify-content: center"
                    >
                      <v-btn
                        @click="getExpireProduct"
                        type="button"
                        class="btn_add_data"
                        elevation="4"
                        large
                        >ค้นหา</v-btn
                      >
                    </div>
                  </v-col>
                  <v-col
                    class="mt-2"
                    xs="12"
                    sm="12"
                    md="1"
                    lg="1"
                    xl="1"
                    cols="12"
                  >
                    <div
                      class="title_page ma-3"
                      style="justify-content: center"
                    >
                      <v-btn
                        @click="exportToExcel"
                        type="button"
                        class="btn_export_excel"
                        elevation="4"
                        large
                        >Export</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="mb-10">
        <Transition name="slide-fade">
          <v-card v-if="show" elevation="4" style="border-radius: 15px">
            <v-card-text>
              <div class="pa-4">
                <v-form ref="#">
                  <v-row>
                    <v-col cols="12" class="mt-5">
                      <div class="d-flex">
                        <div class="text-center">
                          <div class="content-header-title">
                            รายการสินค้าใกล้หมดอายุ
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <v-row class="border-color-milk">
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">ล๊อตสินค้า</th>
                                <th class="text-left">ชื่อสินค้า</th>
                                <th class="text-left">วันหมดอายุ</th>
                                <th class="text-left">จำนวน</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="item in data_list"
                                :key="item.product_name"
                              >
                                <td>{{ item.lot_no }}</td>
                                <td>{{ item.product_name }}</td>
                                <td>{{ item.date_expired }}</td>
                                <td>{{ item.quantity }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </Transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import * as XLSX from "xlsx"; // เพิ่มส่วนนี้สำหรับการ export excel
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Search_expire_product",
  data() {
    const currentYear = new Date().getFullYear();

    return {
      show: false,
      lot_id: null,
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,
      selectedMonth: 1,
      selectedYear: currentYear,
      months: [
        { id: 1, month: "มกราคม" },
        { id: 2, month: "กุมภาพันธ์" },
        { id: 3, month: "มีนาคม" },
        { id: 4, month: "เมษายน" },
        { id: 5, month: "พฤษภาคม" },
        { id: 6, month: "มิถุนายน" },
        { id: 7, month: "กรกฎาคม" },
        { id: 8, month: "สิงหาคม" },
        { id: 9, month: "กันยายน" },
        { id: 10, month: "ตุลาคม" },
        { id: 11, month: "พฤศจิกายน" },
        { id: 12, month: "ธันวาคม" },
      ],
      years: [currentYear - 1, currentYear, currentYear + 1],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "ค้นหาสินค้าใกล้หมดอายุ",
          disabled: false,
          href: "#",
        },
      ],
      data_list: [],
      search: "",
    };
  },
  methods: {
    getExpireProduct() {
      // ตรวจสอบว่าได้เลือกวันเริ่มต้นและวันสิ้นสุดแล้ว
      if (!this.startDate || !this.endDate) {
        alert("กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุด");
        return;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(
        `/pos/expired?startDate=${this.startDate}&endDate=${this.endDate}`,
        config
      ).then((res) => {
        // HTTP_ARIN.get(`/pos/expired?month=4&year=2026`, config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
          this.loading_page = false;
          this.show = true;
        }
      });
    },
     exportToExcel() {
        if (this.data_list.length === 0) {
            alert('ไม่มีข้อมูลสำหรับ Export');
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(this.data_list);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "รายการสินค้าใกล้หมดอายุ");

        XLSX.writeFile(workbook, "รายการสินค้าใกล้หมดอายุ.xlsx");
    }
  },
  mounted() {
    // this.getLot_no();
  },
};
</script>

<style>
.btn_add_data {
  font-size: 16px;
  color: rgb(255, 255, 255) !important;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 100%;
}

.border-color-milk {
  border: 1px solid #d6bfaf;
  border-radius: 10px;
  margin: 0;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 22px;
}

.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.logo_timeline {
  padding: 6px;
}

.logo_timeline > img {
  max-width: 25px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616a6b !important;
}

.input-radius {
  border-radius: 10px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

@media only screen and (max-width: 600px) {
  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }
}
</style>